export default __webpack_public_path__ + "static/media/loyola8.4f013801.jpg";